<ion-header [ngClass]="borderHeader" mode="md">
  <ion-toolbar *ngIf="colors" [color]="colors.colorToolbar" mode="md">
    <ion-badge
      color="danger"
      mode="ios"
      class="ion-no-padding badge-menu"
      *ngIf="!showBackArrow && menuHamburguer && isBadge"
      >0</ion-badge
    >
    <ion-buttons slot="start" style="width: 14%; margin: 0 auto 0 0" mode="md">
      <ion-menu-button
        menu="first"
        *ngIf="!showBackArrow && menuHamburguer"
        color="tpplus"
        (click)="onAnalytic(titulo, 'menu')"
      ></ion-menu-button>

      <ng-container *ngIf="showBackArrow">
        <ion-button
          mode="md"
          fill="clear"
          shape="round"
          class="ion-no-padding"
          (click)="onAnalytic(titulo, 'atras')"
        >
          <ion-icon
            slot="icon-only"
            [name]="colors.iconBack"
            color="white"
          ></ion-icon>
        </ion-button>
      </ng-container>
    </ion-buttons>

    <ion-label mode="md" class="title-module" [ngClass]="colors.classText">
      {{ titulo }}
    </ion-label>

    <ion-buttons slot="end" mode="md">
      <ng-container *ngIf="help">
        <ion-button
          (click)="onHelp()"
          class="mpe-button-icon-circle mpe-no-padding icon-help"
          size="default"
          mode="md"
          shape="round"
          color="darkblue"
          fill="clear"
        >
          <ion-icon name="help-circle-outline" color="darkblue"></ion-icon>
        </ion-button>
      </ng-container>

      <ng-container *ngFor="let boton of MenuHeader | async">
        <!-- * Para validar si se muestra los demas -->
        <ng-template #principals>
          <ng-container *ngIf="!isGame; else botonTemplate"></ng-container>
        </ng-template>

        <ng-container [ngSwitch]="boton.tab">
          <!-- * Para validar si se muestra notificaciones -->
          <ng-container *ngSwitchCase="'notificationes'">
            <ng-container
              *ngIf="showBackArrow; else botonTemplate"
            ></ng-container>
          </ng-container>

          <!-- * Para validar si se muestra juegos -->
          <ng-container *ngSwitchCase="'juegos'">
            <ng-container *ngIf="!isGame; else botonTemplate"></ng-container>
          </ng-container>

          <!-- * Para validar si se muestra los demás -->
          <ng-container *ngSwitchDefault>
            <ng-container
              *ngIf="!isViewBottons; else botonTemplate"
            ></ng-container>
          </ng-container>
        </ng-container>

        <ng-template #botonTemplate>
          <ng-container *ngIf="boton.active">
            <ion-button
              class="mpe-button-icon-circle mpe-no-padding"
              size="default"
              mode="md"
              [shape]="boton.tab === 'notificationes' ? 'default' : 'round'"
              color="darkblue"
              fill="clear"
              (click)="onModule(boton)"
              [ngClass]="boton.itemclass"
            >
              <ng-container *ngIf="boton.tab === 'notificationes'">
                <badge-notifications></badge-notifications>
              </ng-container>

              <ion-icon color="darkblue" [src]="boton.iconUrl"></ion-icon>
            </ion-button>
          </ng-container>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="isPopup">
        <ion-chip
          color="gray-blue"
          mode="md"
          class="chips"
          [ngClass]="isPopupStatus ? 'active' : 'inactive'"
        >
          <ion-icon [src]="'Icons.heart-life' | translate"></ion-icon>

          <ng-container *ngIf="isPopupStatus">
            <ion-label mode="md" class="animated fast fadeIn">
              {{ livesEarn }}
            </ion-label>
          </ng-container>
        </ion-chip>
      </ng-container>
    </ion-buttons>

    <!-- Etiqueta si es desarrollo -->
    <ng-container *ngIf="!isProd && !showBackArrow">
      <div class="ribbon-wrapper">
        <div class="ribbon">
          <ion-label color="white-light">
            {{ labelDebug }}
          </ion-label>
        </div>
      </div>
    </ng-container>
  </ion-toolbar>
</ion-header>
